
















































































































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import EditableTree from '@root/components/data-layout/editable-tree.vue';
import OrganizationSearch from '@/components/organization-search/index.vue';
import AddEditModal from './components/add-edit-modal.vue';
import ResetPasswordModal from './components/reset-password-modal.vue';
import toTree, { ITreeNode } from '@root/utils/to-tree';
import localCache from '@root/utils/local-cache';
import Utils from '@root/utils/common';
import moment from 'moment';
import * as _ from 'lodash';

import { DictUserStatus, DictUserStatusMap, deusermodeMap } from '@/types/system-management/dictionaries';
import {
  getUserList,
  IGetUserListParam,
  deleteUser,
  getPositionList,
  addOrEditUser
} from '@/api/system-management/index';

import { getParkingTree, getParkingOldTree } from '@/api/login-parking';
import { isShiDaill } from '@/utils/env';

@Component({
  name: 'UserList',
  components: {
    EditableTree,
    AddEditModal,
    OrganizationSearch,
    ResetPasswordModal
  }
})
export default class UserList extends Mixins(TableMixin, TableWidthMixin) {
  isShiDaill = isShiDaill;
  // 查询条件
  status = ''; //用户状态
  userName = ''; // 账号
  realName = ''; // 真实姓名
  orgDepId: string[] | string | null = null; // 机构Id
  positionId: string = ''; // 岗位id
  searchValue = ''; // 查询条件内容值
  searchType = 'userName'; // 查询条件下拉框当前值
  positionOptions: IOption[] = []; // 岗位下拉选项

  // 弹窗控制
  addEditModalVisible: boolean = false;
  isEdit: boolean = false;
  addEditModalData: any = [];
  resetPasswordModaVisible: boolean = false;
  resetPasswordUserId: string = '';

  // 所属车场树状图列表
  parkTree: ITreeNode<any>[] = [];
  getParkTreeDebounce: any = null;
  parkTreeLoading: boolean = false;
  usermodeOption: IOption[] = Utils.toLabelVal(deusermodeMap);
  tableData: any[] = []; // 表数据
  tableLoading: boolean = false;
  dictUserStatus = DictUserStatus; //用户状态字典
  dictUserStatusMap = DictUserStatusMap; //用户状态字典map
  currentUser: any = {};
  wenlv: boolean = 'wenlv,wenlvtest'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV);
  // 查询条件下拉框选项
  get searchOption() {
    return [
      {
        value: 'userName',
        label: '登录账号'
      },
      {
        value: 'realName',
        label: '真实姓名'
      }
    ];
  }

  // 左右栏配置
  get flexColumns() {
    return [
      {
        id: 'table',
        hiddenHeader: true,
        padding: '10px 20px 0 0'
      },
      {
        id: 'tree',
        hiddenHeader: true,
        width: '300px',
        padding: '10px 0 0 10px'
      }
    ];
  }

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '登录账号',
        dataIndex: 'userName',
        width: 120,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '真实姓名',
        dataIndex: 'realName',
        width: 120,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '手机号码',
        dataIndex: 'phone',
        width: 140
      },
      {
        title: '所属机构',
        dataIndex: 'orgDepName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '用户岗位',
        dataIndex: 'positionList',
        width: 170,
        scopedSlots: { customRender: 'positionList' }
        //customRender: (text: any) => (_.isArray(text) ? (text[0] && text[0].positionName) || '' : text || ''),
      },
      {
        title: '用户状态',
        dataIndex: 'status',
        width: 100,
        scopedSlots: { customRender: 'status' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 280,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  /**
   * 获取用户岗位
   */
  getPositionName(text) {
    if (_.isArray(text)) return (text[0] && text[0].positionName) || '';
    return '';
  }
  /**
   * 生命周期
   */

  mounted() {
    this.getParkTreeDebounce = _.debounce(this.getParkingTree, 1000);
    this.fetchTableData();
  }

  /**
   * method
   */

  /**
   * 查询机构列表
   */
  async fetchTableData(isRefresh?: boolean) {
    if (this.tableLoading) return false;
    this.tableLoading = true;
    if (isRefresh) this.current = 1;
    try {
      const { status, data } = await getUserList({
        userName: this.searchType === 'userName' ? this.searchValue : '',
        realName: this.searchType === 'realName' ? this.searchValue : '',
        positionId: this.positionId || '',
        orgDepId: this.orgDepId || '',
        currPage: this.current,
        pageSize: this.pageSize,
        // @ts-ignore
        status: this.status
      });
      const { datas = [], totalNum = 0 } = data || {};
      this.tableData = datas;
      this.total = Number(totalNum);
      if (datas.length > 0) {
        this.getCurrentUser(datas[0]);
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  /**
   * 清空查询条件
   */
  onTableFilterClear() {
    this.userName = ''; // 账号
    this.realName = ''; // 真实姓名
    this.searchValue = '';
    this.orgDepId = null; // 机构Id
    this.positionId = ''; // 岗位组id
    this.status = '';
    this.fetchTableData(true);
  }

  /**
   * 更新岗位下拉选项
   */
  async onChangeOrgDepId(value: string) {
    if (!value) return false;
    try {
      const { status, code, msg, data = [] } = await getPositionList({
        orgDepId: value || ''
      });
      this.positionOptions = data;
      this.positionId = '';
    } catch (error) {
      this.$message.error('获取岗位失败');
    }
  }

  /**
   * 表格行删除
   */
  async onTableDelete(key: string) {
    try {
      const { status, code, msg, data } = await deleteUser({
        userId: key
      });
      this.$message.success('删除成功');
      this.fetchTableData();
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }

  /**
   * 展示详情
   */
  async getCurrentUser(item: any) {
    this.currentUser = {
      ...item,
      positionName: (item.positionList && item.positionList[0] && item.positionList[0].positionName) || '--'
    };
    this.getParkTreeDebounce();
  }

  async getParkingTree(userId: string) {
    this.parkTreeLoading = true;
    try {
      const { data = [] } = await getParkingOldTree({
        // const { data = [] } = await getParkingTree({
        userId: this.currentUser.userId || ''
      });
      this.parkTree = toTree(data, {
        idProp: 'id',
        parentProp: 'parentId',
        titleProp: 'name',
        keyFieldMap: 'value',
        titleFieldMap: 'title'
      });
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.parkTreeLoading = false;
    }
  }

  /**
   * 新建弹窗展示
   */
  showAddModal() {
    this.isEdit = false;
    this.addEditModalVisible = true;
    this.addEditModalData = [];
  }
  /**
   * 编辑弹窗展示
   */
  showEditModal(item: any) {
    this.isEdit = true;
    this.addEditModalData = {
      ...item,
      positionIdList: item.positionList.map((item: any) => item.positionId)
    };
    this.addEditModalVisible = true;
  }

  /**
   * 弹窗取消
   */
  handleModalCancel() {
    this.addEditModalVisible = false;
  }
  /**
   * 弹窗保存
   */
  handleModalCreate() {
    this.addEditModalVisible = false;
    this.fetchTableData();
  }

  /**
   * 重置密码弹窗展示
   */
  showResetPasswordModal(userId: string) {
    this.resetPasswordUserId = userId;
    this.resetPasswordModaVisible = true;
  }
  /**
   * 重置密码弹窗关闭
   */
  resetPasswordModalClose() {
    this.resetPasswordModaVisible = false;
  }

  /**
   * 是否是一级及以上机构用户
   */
  isRootUser() {
    return localCache.get('orgDepType') !== 'child';
  }

  /**
   * 解锁
   */
  async unlock(data: Record<string, any>) {
    try {
      let result = await addOrEditUser({
        userId: data.userId,
        lockStatus: '0'
      });
      this.fetchTableData();
    } catch (e) {
      this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
    }
  }
}
